import { useParams } from 'react-router-dom';
import { useSetBreadcrumbName } from 'hooks';
import { getSegment } from 'api/node/segments';

const SegmentBreadcrumb = () => {
  const { segmentId } = useParams();

  useSetBreadcrumbName({
    path: `/settings/experiences/segments/${segmentId}`,
    query: getSegment,
    variables: { segmentId },
    formatData: (data) =>
      Boolean(data?.data) ? `${data?.data?.displayName} ` : null,
  });

  return null;
};

export default SegmentBreadcrumb;
